/**
 * Language toggle — the storefront's one bilingual switch, shared by every
 * root route (landing, event-page, order-access) since none share a parent
 * chrome to host it once. LocalizeMixin re-renders it on locale change, so
 * the label stays live; each host positions it — this component renders
 * only the button.
 */
import { SchmancyElement, schmancyElement } from "@mhmo91/schmancy/mixins";
import { html } from "lit";
import { LocalizeMixin, setUiLanguage } from "../i18n/localize.ts";

@schmancyElement("language-toggle")
export class LanguageToggle extends LocalizeMixin(SchmancyElement) {
	override render() {
		return html`
			<schmancy-button
				variant="outlined"
				size="sm"
				class="h-full"
				@click=${() => setUiLanguage(this.uiLanguage === "de" ? "en" : "de")}
			>
				${this.uiLanguage === "de" ? "EN" : "DE"}
			</schmancy-button>
		`;
	}
}

declare global {
	interface HTMLElementTagNameMap {
		"language-toggle": LanguageToggle;
	}
}
